"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes$ = exports.FastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes$outboundSchema = exports.FastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes$inboundSchema = void 0;
exports.fastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributesToJSON = fastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributesToJSON;
exports.fastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributesFromJSON = fastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const propertiessoldwrapper_js_1 = require("./propertiessoldwrapper.js");
/** @internal */
exports.FastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes$inboundSchema = z.object({
    end_date: z.string().datetime({ offset: true }).transform(v => new Date(v)),
    start_date: z.string().datetime({ offset: true }).transform(v => new Date(v)),
    stats: propertiessoldwrapper_js_1.PropertiesSoldWrapper$inboundSchema,
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "end_date": "endDate",
        "start_date": "startDate",
    });
});
/** @internal */
exports.FastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes$outboundSchema = z.object({
    endDate: z.date().transform(v => v.toISOString()),
    startDate: z.date().transform(v => v.toISOString()),
    stats: propertiessoldwrapper_js_1.PropertiesSoldWrapper$outboundSchema,
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        endDate: "end_date",
        startDate: "start_date",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var FastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes$;
(function (FastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes$) {
    /** @deprecated use `FastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes$inboundSchema` instead. */
    FastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes$.inboundSchema = exports.FastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes$inboundSchema;
    /** @deprecated use `FastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes$outboundSchema` instead. */
    FastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes$.outboundSchema = exports.FastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes$outboundSchema;
})(FastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes$ || (exports.FastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes$ = FastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes$ = {}));
function fastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributesToJSON(fastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes) {
    return JSON.stringify(exports.FastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes$outboundSchema
        .parse(fastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes));
}
function fastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.FastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'FastapiKrakenEndpointsStatsModelsSalesNationalGetPropertiesSoldNationalResponsesStatsPropertiesSoldAttributes' from JSON`);
}
//# sourceMappingURL=fastapikrakenendpointsstatsmodelssalesnationalgetpropertiessoldnationalresponsesstatspropertiessoldattributes.js.map